import {
  UpdateShopifyOrderActionStep,
  UpdateShopifyOrderField,
} from "@redotech/redo-flows-common/oms/actions";
import { useTranslation } from "@redotech/redo-i18n";
import {
  RedoListItem,
  TextRedoListItem,
} from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo } from "react";
import { PartialWithRequiredType } from ".";

export const UpdateShopifyOrderInput = memo(function UpdateShopifyOrderInput({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<UpdateShopifyOrderActionStep>;
  setStep: (
    step: PartialWithRequiredType<UpdateShopifyOrderActionStep>,
  ) => void;
}) {
  const { t } = useTranslation();
  const updateFieldOptions: TextRedoListItem<UpdateShopifyOrderField>[] =
    useMemo(
      () => [
        {
          id: UpdateShopifyOrderField.SHIPPING_LABEL_COST,
          type: "text" as const,
          value: UpdateShopifyOrderField.SHIPPING_LABEL_COST,
          text: t("Shipping label cost"),
        },
      ],
      [t],
    );
  const selected = updateFieldOptions.find((o) => o.value === step.updateField);

  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium">
        {t("Field to update")}
      </Text>
      <RedoSingleSelectDropdownInput<UpdateShopifyOrderField>
        fitToAnchor={false}
        options={updateFieldOptions}
        optionSelected={({
          item,
        }: {
          item: RedoListItem<UpdateShopifyOrderField>;
        }) => setStep({ ...step, updateField: item.value })}
        placeholder={t("Select a field")}
        selectedItem={selected}
        size="xs"
      />
    </Flex>
  );
});
